var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreyPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.75 10.1482C20.75 7.23337 19.6699 4.98983 18.0034 3.48107C16.3496 1.98387 14.1636 1.25001 12 1.25C9.83643 1.24999 7.65035 1.98385 5.99663 3.48105C4.33015 4.98981 3.25 7.23335 3.25 10.1482C3.25 14.0136 5.5502 17.2379 7.65992 19.3941L7.70691 19.4421L7.70693 19.4421C8.37418 20.1242 8.95657 20.7195 9.59294 21.1274C10.2895 21.5738 11.0303 21.788 12.0002 21.788C12.9702 21.788 13.711 21.5737 14.4075 21.1273C15.0439 20.7194 15.6262 20.1241 16.2935 19.442L16.2935 19.4419L16.3405 19.3939C18.45 17.2377 20.75 14.0135 20.75 10.1482ZM15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10Z",
    fill: "#7A8BA7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyPin);
export default __webpack_public_path__ + "static/media/GreyPin.526dd9c729abc9d30b2b3ef6ca94dd9d.svg";
export { ForwardRef as ReactComponent };